/**
 * Created by charnjeetelectrovese@gmail.com on 7/9/2019.
 */
import React, { Suspense } from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import WaitingComponent from "../components/Waiting.component";
import Constants from "../config/constants";

const CustomRouter = (props) => {
  const { component: Component, roles, ...rest } = props;
  const { is_authenticated, role } = useSelector((state) => state.auth);

  if (!is_authenticated && props.private) {
    return (
      <Route
        {...rest}
        render={(childProps) => (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: childProps.location },
            }}
          />
        )}
      />
    );
  }
  if (roles) {
    const isThere =
      role === Constants.ROLES.GENERAL || roles.indexOf(role) >= 0;
    if (!isThere) {
      return (
        <Route
          {...rest}
          render={(childProps) => (
            <Redirect
              to={{
                pathname: "/",
                state: { from: childProps.location },
              }}
            />
          )}
        />
      );
    }
  }
  return (
    <Route
      {...rest}
      render={(childProps) => {
        return (
          <Suspense fallback={<WaitingComponent />}>
            <Component
              {...childProps}
              board_type={props.board_type}
              category={props.category}
              {...props}
            />
          </Suspense>
        );
      }}
    />
  );
};

export default CustomRouter;
